export default __webpack_public_path__ + "static/media/CodeChefLogo.0d9105b8.png";